<template>
    <div>
        <v-row>
            <v-radio-group 
                v-model="recognition_type"
                @change="changeType()"
            >
                <v-radio
                    label="Цифры"
                    value="digit"
                ></v-radio>
                <v-radio
                    label="Слова"
                    value="words"
                ></v-radio>
            </v-radio-group>
        </v-row>
        <v-row v-if="recognition_type == 'digit'">
            <v-col>
                <v-select
                    outlined
                    v-model="selected_digit"
                    :items="digits_list"
                    label="Цифра:"
                    persistent-hint
                    :readonly="stay_on_line"
                    @change="changeDigit()"
                ></v-select>
            </v-col>
            <v-col>
                <v-checkbox
                    v-model="stay_on_line"
                    label="Оставаться на линии"
                    @change="changeDigit()"
                ></v-checkbox>
            </v-col>            
        </v-row>
        <v-row v-if="recognition_type == 'words'">
            <v-col>
                <v-combobox multiple
                    outlined
                    v-model="words_list" 
                    label="Слова:" 
                    append-icon
                    chips
                    deletable-chips
                    class="tag-input"
                    :search-input.sync="word_input" 
                    @keyup.tab="updateTags"
                    @paste="updateTags"
                    @change="changeWord()">
                </v-combobox>
            </v-col>
            <v-col>
                <v-checkbox
                    v-model="any_word"
                    label="Любые слова"
                    @change="changeWord()"
                ></v-checkbox>
            </v-col>
        </v-row>
    </div>
</template>

<script>
export default {
    name: "ivrRecognition",
    props: ["element"],
    data() {
        return {
            recognition_type: "digit",
            digits_list: [
                '1',
                '2',
                '3',
                '4',
                '5',
                '6',
                '7',
                '8',
                '9',
                '0',
                '*',
                '#',
            ],
            selected_digit: '',
            stay_on_line: false,
            words_list: [],
            word_input: "",
            any_word: false,
        }        
    },
    created() {
        if (this.element.hasOwnProperty('keyWords')) {
            this.recognition_type = "words";
            this.words_list = this.element.keyWords.split('|')
        }
        if (this.element.hasOwnProperty('anyWord')) {
            this.recognition_type = "words";
            this.any_word = true;
        }
        if (this.element.hasOwnProperty('digit')) {
            this.recognition_type = "digit";
            this.selected_digit = this.element.digit
            if (this.element.digit == "") {
                this.stay_on_line = true;
            }
        }
    },
    methods: {
        updateTags() {
            this.$nextTick(() => {
                    this.words_list.push(...this.word_input.split(","));
                    this.$nextTick(() => {
                        this.word_input = "";
                    });
            });
        },
        changeWord() {
            if (this.any_word) {
                if (this.element.hasOwnProperty("keyWords")) {
                    delete this.element["keyWords"]
                }
                this.element["anyWord"] = "1"
            } else {
                if (this.element.hasOwnProperty("anyWord")) {
                    delete this.element["anyWord"]
                }
                this.element["keyWords"] = this.words_list.toString().replace(/,/g, "|")
            }
            this.element.ivrs.push();
        },
        changeDigit() {
            if (this.stay_on_line) {
                this.element["digit"] = ""
            } else {
                this.element["digit"] = this.selected_digit
            }
            this.element.ivrs.push();
        },
        changeType() {
            if (!this.element.hasOwnProperty(this.type)) {
                delete this.element[this.type]
            }
            switch (this.recognition_type) {
                case 'digit':
                        if (this.element.hasOwnProperty("keyWords")) {
                            delete this.element["keyWords"]
                        }
                        if (this.element.hasOwnProperty("anyWord")) {
                            delete this.element["anyWord"]
                        }
                        this.changeDigit();
                    break;
                case 'words':
                        if (this.element.hasOwnProperty("digit")) {
                            delete this.element["digit"]
                        }
                        this.changeWord();
                    break;            
                default:
                    break;
            }
            this.element.ivrs.push();
        },
    }
}
</script>

<style>

</style>